import { keyframes } from 'styled-components'

export const scaleDownCenter = keyframes`
  from {
    opacity: 0;
    transform: scale(1.1) translateY(20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0px)
  }
`

export const slowTopAppear = (start = 20, end = 0) => keyframes`
  0% {
    opacity: 0;
    transform: translateY(${start}px);
  }

  100% {
    opacity: 1;
    transform: translateY(${end}px);
  }
`
export const slowTopAppearWithXPosition = (xPosition = 0, start = 20, end = 0) => keyframes`
  0% {
    opacity: 0;
    transform: translate(${xPosition}, ${start}px);
  }

  100% {
    opacity: 1;
    transform: translate(${xPosition}, ${end}px);
  }
`

export const slowAppear = (props) => {
  const { xStart, xEnd, yStart, yEnd, zStart, zEnd } = props;
  const getPosition = position => `${position ? position : 0  }px`
  return keyframes`
  0% {
    opacity: 0;
    transform: translate3d(${getPosition(xStart)}, ${getPosition(
    yStart
  )}, ${getPosition(zStart)});
  }

  100% {
    opacity: 1;
    transform: translate3d(${getPosition(xEnd)}, ${getPosition(
    yEnd
  )}, ${getPosition(zEnd)});
  }
`
}

export const slowTopAppearWithDelay = (start, end) => keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
    transform: translateY(${start ? start : 20}px);
  }

  100% {
    opacity: 1;
    transform: translateY(${end ? end : 0}px);
  }
`

export const slowRightAppearWithDelay = (start, end) => keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0;
    transform: translateX(${start ? start : 20}px);
  }

  100% {
    opacity: 1;
    transform: translateX(${end ? end : 0}px);
  }
`

export const slowDownDisappear = keyframes`
  0% {
    transform: translateY(0px);
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translateY(20px);
  }
`

export const modalAppear = keyframes`
  from {
    opacity: 0;
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    opacity: 1;
    transform: scale3D(1,1,1);
  }
`

export const slideTop = keyframes`
  0% {
    opacity: 0;
    transform: translateY(5px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`

export const appearAnimation = keyframes`
  0% {
    transform-origin: 0% 0%;
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform-origin: 0% 0%;
    transform: scale(1);
    opacity: 1;
  }
`

export const slideRightAnimation = keyframes`
  0% {
    transform: translateX(-120px);
    opacity: 0;
    transform: rotateZ(-20deg)
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
    transform: rotateZ(0deg)
  }
`

export const slideRightAnimationInOut = keyframes`
  0%, 100% {
    transform: translateX(-120px);
    opacity: 0;
    transform: rotateZ(-20deg)
  }
  2%, 98% {
    transform: translateX(0px);
    opacity: 1;
    transform: rotateZ(0deg)
  }
`

export const fadeInRightAnimation = keyframes`
from {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

to {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
`

export const slideTopAnimationInOut = keyframes`
  0%, 100% {
    transform: translateY(30px);
    opacity: 0;
  }
  3.5%, 96.5% {
    transform: translateY(0px);
    opacity: 1;
  }
`

export const topAppearWithScale = keyframes`
  0% {
    transform: translateY(20px) scale(0.95);
    opacity: 0;
  }
  100% {
    transform: translateZ(0px) scale (1);
    }
  `

export const opacityAppear = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const MapAppear = keyframes`
  from {
    transform: translate(0, 10px);
    opacity: 0;
  }
  to {
    transform: translate(0, 0);
    opacity: 1;
  }
`

export const appearWithPosition = (position, start = 20, end = 0, shift = 0) => {
  const startX = position === 'left'
    ? `${start}px`
    : position === 'right'
      ? `-${start}px`
      : `${shift}`
  const startY = position === 'top'
    ? `${start}px`
    : position === 'bottom'
      ? `-${start}px`
      : `${shift}`
  const endX = position === 'left' || position === 'right' ? end : `${shift}`
  const endY = position === 'top' || position === 'bottom' ? end : `${shift}`
  return keyframes`
    0% {
      transform: translate(${startX}, ${startY});
      opacity: 0;
    }
    100% {
      transform: translate(${endX}, ${endY});
      opacity: 1;
      visibility: visible;
    }
  `
}
